var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:#F5F5F5;}\r\n\t.st2{fill:none;}\r\n\t.st3{fill:#CBCBCB;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 24,
    height: 24
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M21,6.6c0-1-0.8-1.8-1.8-1.8H4.8C3.8,4.8,3,5.6,3,6.6v10.8c0,1,0.8,1.8,1.8,1.8h14.4c1,0,1.8-0.8,1.8-1.8V6.6z  M19.2,6.6L12,11.1L4.8,6.6H19.2z M19.2,17.4H4.8v-9l7.2,4.5l7.2-4.5V17.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnEmail);
export default __webpack_public_path__ + "static/media/icn_email.d30d7b7b5fbf3beaedcbeb94b0daef99.svg";
export { ForwardRef as ReactComponent };